import { render, staticRenderFns } from "./public-form-layout.vue?vue&type=template&id=3f2072b1&"
import script from "./public-form-layout.vue?vue&type=script&lang=js&"
export * from "./public-form-layout.vue?vue&type=script&lang=js&"
import style0 from "./public-form-layout.vue?vue&type=style&index=0&id=3f2072b1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports